import { useQuery } from "react-query";
import { buildRequestHeaders, showMutationAlert } from "utils/helpers";
import { BACKEND_DOMAIN, QUERY_STALE_TIME } from "utils/constants";
import useAlert from "hooks/useAlert";
import { useAccessToken } from "hooks/useAccessToken";

export const buildingsValidateQueryKey = ["buildingsValidate"];

const useQueryBuildingsValidate = (buildingModels: CreateBuildingModelInput[]) => {
    const alert = useAlert();
    const accessToken = useAccessToken();
    const URL = `${BACKEND_DOMAIN}/buildings/validate`

    return useQuery<BuildingsValidationResponse>({
        queryKey: buildingsValidateQueryKey,
        queryFn: async () => {
            const response = await fetch(URL, {
                method: "POST",
                headers: buildRequestHeaders(accessToken),
                body: JSON.stringify(buildingModels),
            });
            if (!response.ok) {
                throw new Error(`Error ${response.status}`);
            }
            return response.json();
        },
        onError: (error) => {
            showMutationAlert(error, alert);
        },
        staleTime: QUERY_STALE_TIME,
        // select: (data) => data,
        enabled: !!buildingModels
    });
};

export default useQueryBuildingsValidate;
